module.exports = __webpack_public_path__ + "static/media/rulet.a544bfc9.png";